module.exports = __webpack_public_path__ + "img/20180414165955.b0f83efe.jpg";